module.exports = __webpack_public_path__ + "assets/img/member.bc7c02fd.png";